/**
 * Created by mykurisu on 2017/7/17.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import '../../styles/component.css'
import BacnToIndexIcon from '../../images/back-to-index.png'


class WKToIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldShow: false,
        };
        this.el = props.el || window
        this.handleScroll = this.handleScroll.bind(this)
    }

    componentDidMount() {
        this.el.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
        this.el.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll() {
        if (this.handleGetScrollTop() > (this.props.minScroll || 168)){
            if (!this.state.shouldShow){
                this.setState({
                    shouldShow: true
                })
            }
        }else {
            if (this.state.shouldShow){
                this.setState({
                    shouldShow: false
                })
            }
        }
    }

    handleGetScrollTop() {
        if (this.el === window) {
            return document.body.scrollTop || document.documentElement.scrollTop
        } else {
            return this.el.scrollTop
        }
    }

    render() {
        return (
            <div className="back-to-index" style={{top: this.props.top ? this.props.top + 'px' : '10px', opacity: this.state.shouldShow ? '1' : '0'}}>
                <div className="back-to-index_entry" style={{pointerEvents: this.state.shouldShow ? 'auto' : 'none'}} onClick={() => window.location = '/'}>
                    <div className="back-to-index_text">
                        回到首页
                    </div>
                    <div className="back-to-index_icon">
                        <img src={BacnToIndexIcon} alt=""/>
                    </div>
                </div>
            </div>
        )
    }
}

export default WKToIndex


// WEBPACK FOOTER //
// ./src/components/wk/WKToIndex.js